// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__3SXLN","radioContainer":"styles_radioContainer__3zkbv","text":"styles_text__15kMl"};